import * as React from 'react';
import { PdsIconSprout as PdsIconSproutElement } from '@principal/design-system-icons-web';
import {
  IconSize,
  ValidIconColor,
} from '../../../utils/icon-utilities';
import { createPdsReactComponent } from '../../../../../react/src/lib/create-pds-react-component';

interface IconProps {
  size?: IconSize;
  color?: ValidIconColor;
}

export const PdsIconSprout = createPdsReactComponent<IconProps>()({
  tagName: 'pds-icon-sprout',
  elementClass: PdsIconSproutElement,
  react: React,
});
